import React from 'react';
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLanguage } from '../../i18n/LanguageContext';
import { ProgramSession } from '../../services/api/ProgramApiService';

interface SessionHistoryListProps {
  sessions: ProgramSession[];
  onEditLast?: () => void;
  onDeleteLast?: () => void;
}

export const SessionHistoryList: React.FC<SessionHistoryListProps> = ({
  sessions,
  onEditLast,
  onDeleteLast,
}) => {
  const { t } = useLanguage();

  if (sessions.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
        {t('programs.noSessions')}
      </Typography>
    );
  }

  return (
    <List disablePadding>
      {[...sessions].reverse().map((session, idx) => (
        <React.Fragment key={session.id}>
          {idx > 0 && <Divider />}
          <ListItem disablePadding sx={{ py: 0.5 }}>
            <ListItemText
              primary={session.template_name}
              secondary={new Date(session.session_date).toLocaleDateString()}
            />
            {idx === sessions.length - 1 && (onEditLast || onDeleteLast) && (
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                {onEditLast && (
                  <IconButton size="small" onClick={onEditLast} title={t('programs.editSession')}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
                {onDeleteLast && (
                  <IconButton size="small" color="error" onClick={onDeleteLast} title={t('programs.deleteSession')}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            )}
          </ListItem>
        </React.Fragment>
      ))}
    </List>
  );
};
